/* eslint-disable no-mixed-operators */
import { is, getBusinessObject } from "bpmn-js/lib/util/ModelUtil";

import candidateStarter from "./CandidateStarter";

export default function (group, element, bpmnFactory, translate, modeling) {
  const businessObject = getBusinessObject(element);

  if (
    is(element, "camunda:Process") ||
    (is(element, "bpmn:Participant") && businessObject.get("processRef"))
  ) {
    group.entries = group.entries.concat(
      candidateStarter(
        element,
        bpmnFactory,
        {
          getBusinessObject(element) {
            const bo = getBusinessObject(element);

            if (!is(bo, "bpmn:Participant")) {
              return bo;
            }

            return bo.get("processRef");
          },
        },
        translate,
        modeling,
      ),
    );
  }
}
